import React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var EcuSVG = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#ED1C23",
  d: "M36 27a4 4 0 01-4 4H4a4 4 0 01-4-4V9a4 4 0 014-4h28a4 4 0 014 4v18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#034EA2",
  d: "M0 17h36v7H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FD0",
  d: "M36 17V9a4 4 0 00-4-4H4a4 4 0 00-4 4v8h36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FD0",
  d: "M23 19a2 2 0 01-2 2h-6a2 2 0 01-2-2v-3a2 2 0 012-2h6a2 2 0 012 2v3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#034EA2",
  d: "M22 18c0 1.104-.896 3-2 3h-4c-1.104 0-2-1.896-2-3v-1a2 2 0 012-2h4a2 2 0 012 2v1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED1C23",
  d: "M21 18c0 1.104-.896 3-2 3h-2c-1.104 0-2-1.896-2-3v-1a2 2 0 012-2h2a2 2 0 012 2v1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6DBE46",
  d: "M19.973 14.135c-.133.488-.961.865-1.973.865s-1.84-.377-1.973-.865C14.822 14.307 15 14.628 15 15c0 .552.791 1 3 1s3-.448 3-1c0-.372.178-.693-1.027-.865z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A6D388",
  d: "M19 19a1 1 0 11-2 0v-3a1 1 0 012 0v3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#662113",
  d: "M21.5 12c.44 0 .858.052 1.246.137C22.123 11.061 20 10 18 12c-2-2-4.123-.939-4.746.137A5.822 5.822 0 0114.5 12c1.933 0 3.5.896 3.5 2 0-1.104 1.566-2 3.5-2z"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#8ED2E7",
  cx: "18",
  cy: "17.5",
  rx: "2",
  ry: "3.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6DBE46",
  d: "M17.5 17c-.536 0-1.037.13-1.491.345-.001.052-.009.102-.009.155 0 1.933.896 3.5 2 3.5 1.003 0 1.825-1.295 1.97-2.979A3.492 3.492 0 0017.5 17z"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFCC4D",
  cx: "18",
  cy: "22",
  rx: "3",
  ry: "1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#034EA2",
  d: "M20 23c0 .828-.896 1-2 1s-2-.172-2-1 .896-2 2-2 2 1.172 2 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED1C23",
  d: "M17 23c0-.828.448-2 1-2s1 1.172 1 2-.448 1-1 1-1-.172-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCD6DD",
  d: "M17 11c0-.552.448 0 1 0s1-.552 1 0a1 1 0 01-2 0z"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFF",
  cx: "18",
  cy: "17.5",
  rx: "1",
  ry: ".5"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#C1694F",
  cx: "13",
  cy: "15.5",
  rx: "1",
  ry: ".5"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#C1694F",
  cx: "14",
  cy: "13.5",
  rx: "1",
  ry: ".5"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#C1694F",
  cx: "23",
  cy: "15.5",
  rx: "1",
  ry: ".5"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#C1694F",
  cx: "22",
  cy: "13.5",
  rx: "1",
  ry: ".5"
})));

export { EcuSVG as default };
//# sourceMappingURL=bundle.esm7.js.map
